//
// GENERATED by KVision
//
package pl.finn.forms.fk02

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.fk02.Fk02Form
import pl.finn.forms.fk02.Fk02FormData

actual class Fk02Service(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : IFk02Service, KVRemoteAgent<Fk02Service>(Fk02ServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(IFk02Service::nowy, token)
    override suspend fun edycja(token: String) = call(IFk02Service::edycja, token)
    override suspend fun sprawdz(fk02Form: Fk02Form, token: String) = call(IFk02Service::sprawdz, fk02Form, token)
    override suspend fun zapisz(fk02Form: Fk02Form, validateResult: String?, token: String) = call(IFk02Service::zapisz, fk02Form, validateResult, token)
    override suspend fun podglad(fk02Form: Fk02Form, token: String) = call(IFk02Service::podglad, fk02Form, token)
}
